import { Component } from "react"
import PropTypes from "prop-types"
import { SECURITY } from "../../shapes"
import { treatAsFactor } from "helpers/securities"
import DisplayPositionName from "components/display-position-name"
import "./style.scss"

class Position extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
    row: SECURITY.isRequired,
    openSecurityProfile: PropTypes.func.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
  }

  onClick = () => {
    const { row: { ticker, exchange, assetClass }, openSecurityProfile, openFactorProfile } = this.props

    if (treatAsFactor(assetClass)) {
      openFactorProfile(ticker)
    } else {
      openSecurityProfile(exchange, ticker)
    }
  }

  render() {
    const { row, children } = this.props
    const positionName = row.country
      ? <DisplayPositionName country={row.country} ticker={row.ticker || row.key} />
      : row.ticker || row.key

    return <tr className="row position">
      <th title={row.description}>
        {row.ticker && row.exchange
          ? <a onClick={this.onClick}>{positionName}</a>
          : positionName}
      </th>
      {children}
    </tr>
  }
}

export default Position
